import React from 'react'

const Quote = () => {
  return (
    <>
      <section className='max-w-[1040px]  p-8  mx-auto hidden lg:block'>
        <h2 className='text-2xl text-center text-gray-500 mb-9 pt-3'>25000+ Students have benefited from our Companion</h2>
        <div className='w-[50rem] h-[14rem] flex flex-col items-center justify-center rounded-br-[6rem] rounded-tl-[6rem] mx-auto px-10 shadow-xl border-2'>
            <h3 className='text-xl text-gray-600 text-center'>"College predictors helped me to timely shortlist the best colleges for me. the team for making this tool"</h3>
        </div>
      </section>
    </>
  )
}

export default Quote
